import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import DOMPurify from 'dompurify';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export default function EditDetails() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email;
    const accountType = location.state?.accountType;
    const apiKey = process.env.REACT_APP_API_KEY;
    const baseURL = process.env.REACT_APP_BASE_URL;
    const [stateData, setStateData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [agegroupData, setAgegroupData] = useState([]);
    const [genderData, setGenderData] = useState([]);
    const [genres, setGenres] = useState([]);
    const [mentors, setMentors] = useState([]);
    const [languages, setLanguages] = useState([]);
    const userId = localStorage.getItem('userid');
    // Regular expression for strong password
    const strongPasswordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/;
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { isAuthenticated } = useAuth();


    const [formData, setFormData] = useState({
        password: '',
        email: email,
        name: "",
        phonenumber: "",
        user_role: "",
        languages: [],
        genre_ids: [],
        readingpreferenceid: 0,
        readingtimeid: 0,
        stateid: 0,
        districtid: 0,
        zipcode: "",
        agegroupid: 0,
        mentorid: 0,
        mentor_name: "",
        fcm_token: "",
        genderid: 0,
        dob: "",
        is_profile_completed: true,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = DOMPurify.sanitize(value);

        setFormData({
            ...formData,
            [name]: sanitizedValue,
        });

        // Check password validity on change
        if (name === 'password') {
            setIsPasswordValid(strongPasswordRegex.test(value));
        }



    };

    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirm_password) {
            setErrorMessage('Passwords do not match');
            toast.error('Passwords do not match');
            return;
        }


        // Validate password before submitting
        if (!isPasswordValid) {
            toast.error('Password should be at least 8 characters long and contain at least one digit, one uppercase letter, and one special character.');
            return;
        }
        setIsLoading(true);
        try {
            const sanitizedName = DOMPurify.sanitize(formData.name, { SAFE_FOR_TEMPLATES: true });
            const sanitizedUsername = DOMPurify.sanitize(formData.email, { SAFE_FOR_TEMPLATES: true });
            const sanitizedPassword = DOMPurify.sanitize(formData.password, { SAFE_FOR_TEMPLATES: true });
            const sanitizedPhonenumber = DOMPurify.sanitize(formData.phonenumber, { SAFE_FOR_TEMPLATES: true });
            const sanitizedState = DOMPurify.sanitize(formData.stateid, { SAFE_FOR_TEMPLATES: true });
            const sanitizedDistrict = DOMPurify.sanitize(formData.districtid, { SAFE_FOR_TEMPLATES: true });
            const sanitizedZipcode = DOMPurify.sanitize(formData.zipcode, { SAFE_FOR_TEMPLATES: true });
            const sanitizedAgegroupid = DOMPurify.sanitize(formData.agegroupid, { SAFE_FOR_TEMPLATES: true });
            const sanitizedMentorid = DOMPurify.sanitize(formData.mentorid, { SAFE_FOR_TEMPLATES: true });
            const sanitizedMentorName = DOMPurify.sanitize(formData.mentor_name, { SAFE_FOR_TEMPLATES: true });
            const sanitizedGenderid = DOMPurify.sanitize(formData.genderid, { SAFE_FOR_TEMPLATES: true });
            const sanitizedDOM = DOMPurify.sanitize(formData.dob, { SAFE_FOR_TEMPLATES: true });


            const response = await fetch(`${baseURL}/user-register`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    account_type: accountType || 5,
                    name: sanitizedName,
                    password: sanitizedPassword,
                    email: sanitizedUsername,
                    user_source: "Web",
                    phonenumber: sanitizedPhonenumber,
                    user_role: "",
                    languages: formData.languages,
                    genre_ids: formData.genre_ids,
                    readingpreferenceid: 0,
                    readingtimeid: 0,
                    stateid: sanitizedState,
                    districtid: sanitizedDistrict,
                    zipcode: sanitizedZipcode,
                    agegroupid: sanitizedAgegroupid,
                    mentorid: sanitizedMentorid,
                    mentor_name: sanitizedMentorName,
                    fcm_token: "",
                    genderid: sanitizedGenderid,
                    dob: sanitizedDOM,
                    is_profile_completed: true,
                }),
            });

            const result = await response.json();
            console.log('Response body:', result);
            if (response.ok) {
                if (result.status_code === 200) {
                    const { access_token, refresh_token, user } = result;
                    localStorage.setItem('access_token', access_token);
                    localStorage.setItem('refresh_token', refresh_token);
                    localStorage.setItem('userid', user[0].userid);
                    login();
                    navigate('/home');
                }
                else {
                    toast.error(result.message);
                }
            }
            else {
                toast.error(result.message);
            }
        } catch (error) {
            setErrorMessage('An error occurred during registration.');
        }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseURL}/basicdata/?userid=${userId}`, {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': apiKey
                    }
                });

                setStateData(response.data.states_data);
                setDistrictData(response.data.districts_data);
                setAgegroupData(response.data.agegroup_data);
                setGenderData(response.data.genders_data);

            } catch (error) {
                console.error('Error fetching data:', error);

            }
        };

        if (userId) {
            fetchData();
        }
    }, [userId, baseURL, apiKey]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseURL}/get_genre`, {
                    headers: {
                        'accept': 'application/json'
                    }
                });
                console.log('Response data:', response.data);
                setGenres(response.data);

            } catch (error) {
                console.error('Error fetching data:', error);

            }
        };

        if (userId) {
            fetchData();
        }
    }, [userId, baseURL]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseURL}/languages`, {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': apiKey
                    }
                });
                console.log('Response data:', response.data);
                setLanguages(response.data);

            } catch (error) {
                console.error('Error fetching data:', error);

            }
        };

        if (userId) {
            fetchData();
        }
    }, [userId, baseURL, apiKey]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseURL}/get_mentor`, {
                    headers: {
                        'accept': 'application/json'
                    }
                });
                console.log('Response data:', response.data);
                setMentors(response.data);

            } catch (error) {
                console.error('Error fetching data:', error);

            }
        };

        if (userId) {
            fetchData();
        }
    }, [userId, baseURL]);

    const handleChange1 = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = DOMPurify.sanitize(value);

        if (name === 'stateid') {

            const selectedState = stateData.find(state => state._id === parseInt(sanitizedValue));
            const filteredDistricts = districtData.filter(district => district.stateid === selectedState._id);


            setFormData({
                ...formData,
                [name]: parseInt(sanitizedValue),
                districtid: filteredDistricts.length > 0 ? filteredDistricts[0]._id : 0,
            });
        } else {

            setFormData({
                ...formData,
                [name]: sanitizedValue,
            });
        }
    };



    const handleDateChange = (date, setFormData) => {
        setFormData((prevState) => ({
            ...prevState,
            dob: date.toISOString().split('T')[0], // Save DOB in "YYYY-MM-DD" format
        }));
    };

    const handlePhoneNumber = (e) => {
        const input = e.target.value;
        const sanitizedInput = DOMPurify.sanitize(input.replace(/\D/g, '').slice(0, 10));
        setFormData(prevFormData => ({ ...prevFormData, phonenumber: sanitizedInput }));
    };


    // Function to generate options for the Select component
    const getLanguageOptions = (languages) => {
        return languages.map((language) => ({
            value: language._id,
            label: language.language,
        }));
    };

    // Function to filter and map selected languages based on formData
    const getSelectedLanguages = (languages, formData) => {
        return languages
            .filter((language) => formData.languages.includes(language._id))
            .map((language) => ({
                value: language._id,
                label: language.language,
            }));
    };

    // Function to handle changes in the Select component
    const handleLanguageChange = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value);
        setFormData((prevState) => ({
            ...prevState,
            languages: selectedIds, // Update formData.languages
        }));
    };


    // Function to generate options for the Select component
    const getGenreOptions = (genres) => {
        return genres.data
            ? genres.data.map((genre) => ({
                value: genre._id,
                label: genre.category_name,
            }))
            : [];
    };

    // Function to filter and map selected genres based on formData
    const getSelectedGenres = (genres, formData) => {
        return genres.data
            ? genres.data
                .filter((genre) => formData.genre_ids.includes(genre._id))
                .map((genre) => ({
                    value: genre._id,
                    label: genre.category_name,
                }))
            : [];
    };

    // Function to handle changes in the Select component
    const handleGenreChange = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value);
        setFormData((prevState) => ({
            ...prevState,
            genre_ids: selectedIds,
        }));
    };

    if (isAuthenticated) {
        return <Navigate to="/" />;
    }


    return (
        <>

            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                theme="dark"
            />



            <section className="my-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="account-card">
                                <div className="account-title">
                                    <h4>Fill Your Details</h4>

                                </div>
                                <div className="account-content">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">

                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor='name'>name</label>
                                                    <input id='name' className="form-control" type="text" name="name" value={formData.name} onChange={handleChange} placeholder="name" required />
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor='password'>Password</label>
                                                    <input type={showPassword ? 'text' : 'password'} id="password" className="form-control" name="password" onChange={handleChange} placeholder='Enter Password' required />
                                                    <span className={`far fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'} eye-icon toggle-password`} onClick={togglePasswordVisibility}></span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor='confirm_password'>Confirm Password</label>
                                                    <input type={showPassword ? 'text' : 'password'} id="confirm_password" className="form-control" name="confirm_password" onChange={handleChange} placeholder='Confirm Password' required />
                                                    <span className={`far fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'} eye-icon toggle-password`} onClick={togglePasswordVisibility}></span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="phonenumber">Phone Number</label>
                                                    <input id="phonenumber" className="form-control" type="text" name="phonenumber" value={formData.phonenumber} onChange={handlePhoneNumber} placeholder="Phone Number" maxLength="10" required />
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor='mentorid'>DOB</label>
                                                    <DatePicker
                                                        selected={formData.dob} // Safely handle invalid or null values
                                                        onChange={(date) => handleDateChange(date, setFormData)} // Call the function here
                                                        className="form-control"
                                                        dateFormat="yyyy-MM-dd" // Display format
                                                        placeholderText="Enter DOB"
                                                        showYearDropdown
                                                        scrollableYearDropdown
                                                        yearDropdownItemNumber={100} // Show dropdown for years (past 100 years)
                                                        maxDate={new Date()} // Prevent selecting a future date
                                                        onKeyDown={(e) => e.preventDefault()}   // Prevent manual typing
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group" htmlFor="gender">
                                                    <label id='gender' className="form-label">Gender</label>
                                                    <select className="form-control" name="genderid" value={formData.genderid} onChange={handleChange} required>
                                                        <option value="">Select Gender</option>

                                                        {genderData.map(gender => (
                                                            <option key={gender._id} value={gender._id} >{gender.gender}</option>
                                                        ))}
                                                    </select>

                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="age">Age Group</label>
                                                    <select id='age' className="form-control" name="agegroupid" value={formData.agegroupid} onChange={handleChange} required>
                                                        <option value="" >Select Age Group</option>

                                                        {agegroupData.map(agegroups => (
                                                            <option key={agegroups._id} value={agegroups._id} >{agegroups.agegroup}</option>
                                                        ))}
                                                    </select>

                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor='mentorid'>Mentor</label>
                                                    <select id='age' className="form-control" name="mentorid" value={formData.mentorid} onChange={handleChange} required>
                                                        <option value="" >Select Mentor</option>

                                                        {mentors.data && mentors.data.map(mentors => (
                                                            <option key={mentors.id} value={mentors.id} >{mentors.role}</option>
                                                        ))}
                                                    </select>

                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor='mentorid'>Mentor Name</label>
                                                    <input type="text" className="form-control  " id="mentor_name" name="mentor_name" value={formData.mentor_name} onChange={handleChange} placeholder='Enter Mentor Name' required />
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="statename">State</label>
                                                    <select id='statename' className="form-control" name="stateid" value={formData.stateid} onChange={handleChange1} required>
                                                        <option value="">Select State</option>
                                                        {stateData.map(state => (
                                                            <option key={state._id} value={state._id} id={state._id}>{state.statename}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="district">District</label>
                                                    <select
                                                        id='district'
                                                        className="form-control dropdown-arrow"
                                                        name="districtid"
                                                        value={formData.districtid}
                                                        onChange={handleChange1}
                                                        required
                                                        disabled={formData.stateid === 0} // Disable if stateid is 0 (default)
                                                    >
                                                        {districtData.map(district => (
                                                            district.stateid === formData.stateid && (
                                                                <option key={district._id} value={district._id}>{district.districtname}</option>
                                                            )
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor='zipcode'>Zip Code</label>
                                                    <input id='zipcode' className="form-control" type="number" name="zipcode" value={formData.zipcode} onChange={handleChange} placeholder="Zip Code" maxLength="6" required />
                                                </div>
                                            </div>


                                            <div className="col-md-6 col-lg-6">
                                                <label className="form-label">Select Languages</label>
                                                <Select
                                                    isMulti
                                                    className=""
                                                    options={getLanguageOptions(languages)}
                                                    value={getSelectedLanguages(languages, formData)}
                                                    onChange={handleLanguageChange}
                                                    placeholder="Select languages"
                                                    required
                                                />


                                            </div>

                                            <div className="col-md-6 col-lg-6">
                                                <label className="form-label">Select Genres</label>
                                                <Select
                                                    isMulti
                                                    className=""
                                                    options={getGenreOptions(genres)}
                                                    value={getSelectedGenres(genres, formData)}
                                                    onChange={handleGenreChange}
                                                    required
                                                />
                                            </div>
                                            {/*  <pre>{JSON.stringify(formData, null, 2)}</pre> */}
                                            {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                                            <div className="col-lg-12">
                                                <div className="section-btn-25">
                                                    <button
                                                        type="submit"
                                                        className='btn-6 view-all-btnn mt-3 text-capitalize'
                                                        disabled={isLoading}
                                                    >
                                                        {isLoading ? <div class="spinner-border" role="status">
                                                            <span class="sr-only">Loading...</span>
                                                        </div> : 'Create a New Account'}
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div class="modal fade set-md-width" id="profile-update" tabindex="-1" aria-labelledby="profile-update" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <button class="modal-close icofont-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div class="modal-body">
                                <div className='row justify-content-center'>
                                    <div className='col-md-10'>

                                        <div className="user-form-title">
                                            <h2>Profile Updated Sucessfuly</h2>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
